import { render, staticRenderFns } from "./CustomMultipleSelect2.vue?vue&type=template&id=2d41daad&scoped=true&"
import script from "./CustomMultipleSelect2.vue?vue&type=script&lang=js&"
export * from "./CustomMultipleSelect2.vue?vue&type=script&lang=js&"
import style0 from "./CustomMultipleSelect2.vue?vue&type=style&index=0&id=2d41daad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d41daad",
  null
  
)

export default component.exports